(() => {
  'use strict';
  const config=document.getElementById('gcp-brown-quote-settings');
  if(!config||window.GCPBrownQuote)return;
  const staged=new Map();
  const normalize=value=>String(value??'').replace(/\s+/g,' ').trim();
  const number=value=>{
    const match=normalize(value).replace(/,/g,'').match(/^\d+(?:\.\d+)?/);
    return match&&Number.isFinite(Number(match[0]))?Number(match[0]):null;
  };
  const property=(item,key)=>{
    const p=item?.properties||{};
    if(Array.isArray(p))return p.find(x=>(x?.name??x?.[0])===key)?.value||p.find(x=>x?.[0]===key)?.[1]||'';
    return p[key]||'';
  };
  const selectionFor=item=>normalize(property(item,'_x1SelectionId')||property(item,'x1SelectionId'));
  const wrapper=()=>document.querySelector('[data-packq-gempages][data-product-handle]');
  const keyFor=el=>el?.dataset.productHandle||'';
  const field=(root,key)=>root?.querySelector('.gcp-native-field--'+key+' input:not([type="hidden"]), .gcp-native-field--'+key+' [role="spinbutton"]');
  const option=(root,key)=>normalize(root?.querySelector('.gcp-native-field--'+key+' select')?.selectedOptions?.[0]?.textContent);
  const selection=()=>normalize(window.GCPPackQCloudLabCartHandoff?.currentManagedPricingState?.()?.selectionId||new URL(location.href).searchParams.get('quote'));
  const sameSize=(a,b)=>['length','width','height','back-height','front-height'].every(key=>Number(a?.[key]||0)===Number(b?.[key]||0));
  const complete=d=>d?.length>0&&d?.width>0&&(d?.height>0||(d?.['back-height']>0&&d?.['front-height']>0));
  const signature=specs=>JSON.stringify([specs.dimensions,specs.material,specs.flute,specs.print]);
  const rememberPath=path=>{
    const w=wrapper();if(!w)return;
    try{sessionStorage.setItem('gcp:brown:path:'+keyFor(w),JSON.stringify({path,at:Date.now()}));}catch(_){}
  };
  const rememberedPath=w=>{
    try{const state=JSON.parse(sessionStorage.getItem('gcp:brown:path:'+keyFor(w))||'{}');return Date.now()-state.at<45*60*1000?state.path:'unknown';}catch(_){return 'unknown';}
  };
  const artifactUrl=value=>{
    try{const url=new URL(value);return url.protocol==='https:'&&url.hostname==='brownpackaging-x4-xir4o.your-cloudlab.com'?url.href:'';}catch(_){return '';}
  };
  const dimensionsFrom=value=>{
    const text=normalize(value);
    if(!/^\d+(?:\.\d+)?(?:\s*[x×]\s*\d+(?:\.\d+)?){2,3}\s*(?:in|inch|inches|")?$/i.test(text))return null;
    const values=text.match(/\d+(?:\.\d+)?/g).map(Number);
    if(values.some(value=>!Number.isFinite(value)||value<=0||value>100000))return null;
    const keys=values.length===4?['length','width','back-height','front-height']:['length','width','height'];
    return Object.fromEntries(keys.map((key,index)=>[key,values[index]]));
  };
  const storedDimensions=id=>{
    if(!id)return null;
    try{return dimensionsFrom(localStorage.getItem('gcp:packq:finished-dimensions:'+id));}catch(_){return null;}
  };
  const liveFields=()=>{
    const w=wrapper(),root=w?.querySelector('#printq_app');
    if(!root)throw Error('configuration_unavailable');
    const dimensions={};
    for(const key of ['length','width','height','back-height','front-height']){
      const value=number(field(root,key)?.value);if(value!==null)dimensions[key]=value;
    }
    if(dimensions['back-height']&&dimensions['front-height'])delete dimensions.height;
    else{delete dimensions['back-height'];delete dimensions['front-height'];}
    const selected=root.querySelector('.gcp-native-quantity-row.gcp-is-selected');
    const quantity=number(selected?.querySelector(':scope > th,:scope > td')?.textContent)||number(field(root,'custom-quantity')?.value);
    return {w,root,specs:{dimensions,unit:'in',quantity,material:option(root,'material'),flute:option(root,'flute'),print:option(root,'print-options')}};
  };
  const liveBrief=()=>{
    const {w,root,specs}=liveFields(),record=staged.get(keyFor(w));
    const file=record?.signature===signature(specs)?record.file:null;
    const image=root.querySelector('.gcp-native-upload-utilities-zone img[src], .gcp-native-upload-utility-wrap img[src], img[src*="/personalization/"]');
    const preview=artifactUrl(image?.currentSrc||image?.src||''),id=selection();
    return {brief:{v:1,source:'product',captured_at:new Date().toISOString(),product:{title:normalize(w.dataset.productTitle),handle:keyFor(w),url:'https://getcustompack.com/products/'+encodeURIComponent(keyFor(w))},specs,artwork:{path:file?'upload':rememberedPath(w),selection_id:id,preview_url:preview,status:file?'file_available':id?'reference_only':'not_supplied'}},file};
  };
  let modulePromise,pendingUpload=null,capturePromise=Promise.resolve();
  const storage=()=>modulePromise||=(import(new URL(config.dataset.module,document.baseURI).href));
  const fetchCart=async()=>{
    const response=await fetch(config.dataset.cartUrl||'/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(12000)});
    if(!response.ok)throw Error('cart_unavailable');
    const cart=await response.json();if(!Array.isArray(cart.items))throw Error('cart_unavailable');return cart;
  };
  const handleFor=item=>{
    const main=normalize(property(item,'_x1MainProductHandle'));
    if(/^[a-z0-9][a-z0-9-]{0,254}$/.test(main))return main;
    const raw=normalize(item.handle||String(item.url||'').match(/\/products\/([a-z0-9-]+)/)?.[1]);
    return /^[a-z0-9][a-z0-9-]{0,254}$/.test(raw)?raw:'custom-project';
  };
  const baseCartBrief=item=>{
    const handle=handleFor(item),id=selectionFor(item);
    const formatted=normalize(property(item,'Selection')||item.variant_title);
    const format=formatted.match(/Custom Format\s*\(([^)]+)\)/i)?.[1];
    const dimensions=dimensionsFrom(property(item,'_gcpFinishedDimensions'))||storedDimensions(id)||dimensionsFrom(format)||{};
    const preview=artifactUrl(property(item,'_x1Image'));
    return {v:1,source:'cart',captured_at:new Date().toISOString(),product:{title:normalize(item.product_title||item.title||handle),handle,url:'https://getcustompack.com/products/'+encodeURIComponent(handle)},specs:{dimensions,unit:'in',quantity:Number(item.quantity),selection:formatted},artwork:{path:/\/personalization\//i.test(preview)?'personalize':'unknown',selection_id:id,preview_url:preview,status:id||preview?'reference_only':'not_supplied'}};
  };
  const matchLive=(brief,live)=>Boolean(live&&brief.artwork.selection_id&&brief.product.handle===live.brief.product.handle&&brief.artwork.selection_id===live.brief.artwork.selection_id&&complete(brief.specs.dimensions)&&sameSize(brief.specs.dimensions,live.brief.specs.dimensions));
  const captureCartArtwork=async(pending=pendingUpload,eventDetail={})=>{
    if(!pending?.value?.file)return false;
    const live=pending.value;
    if(!live.file)return false;
    const cart=await fetchCart();
    const candidates=cart.items.filter(item=>matchLive(baseCartBrief(item),live)&&(!eventDetail.variantId||String(item.variant_id||item.id)===String(eventDetail.variantId)));
    if(candidates.length!==1)return false;
    const item=candidates[0];
    const brief=baseCartBrief(item);
    if(brief.artwork.path==='personalize')return false;
    brief.artwork={...brief.artwork,path:'upload',status:'file_available'};
    for(const key of ['material','flute','print'])brief.specs[key]=live.brief.specs[key];
    const module=await storage();await module.saveArtwork(brief,live.file,item.key);
    return true;
  };
  const buildCartItem=async(item,module)=>{
    const brief=baseCartBrief(item);
    let file=null;
    const local=await module.readArtwork(brief,item.key);
    if(local){
      file=local.file;brief.artwork.path='upload';brief.artwork.status='file_available';
      for(const key of ['material','flute','print'])if(local.brief.specs[key])brief.specs[key]=local.brief.specs[key];
    }
    return {id:crypto.randomUUID(),brief,file,included:true};
  };
  const cartProject=async line=>{
    await capturePromise;
    const [cart,module]=await Promise.all([fetchCart(),storage()]);
    const old=line?.item||line,id=selectionFor(old);
    const selected=cart.items.find(item=>old?.key&&item.key===old.key)||cart.items.find(item=>id&&selectionFor(item)===id);
    if(!selected)throw Error('cart_item_changed');
    const source=cart.items.filter(item=>!item.gift_card&&Number.isSafeInteger(Number(item.quantity))&&Number(item.quantity)>0);
    const items=[];let trigger='';
    for(const item of source){
      const value=await buildCartItem(item,module);items.push(value);if(item===selected)trigger=value.id;
    }
    if(!items.length||!trigger)throw Error('cart_item_changed');
    return {items,trigger_id:trigger};
  };
  const cartBrief=async line=>{
    const project=await cartProject(line);return project.items.find(item=>item.id===project.trigger_id);
  };
  const errorMessage=error=>{
    const key=error?.message==='popup_blocked'?'popupBlocked':error?.message==='storage_unavailable'?'storageUnavailable':error?.message==='cart_item_changed'?'cartChanged':error?.message==='cart_unavailable'?'cartUnavailable':'error';
    return config.dataset[key]||config.dataset.error;
  };
  const open=async(options={})=>{
    const target=window.open('about:blank','_blank');
    if(!target)throw Error('popup_blocked');
    try{
      target.opener=null;
      const note=target.document.createElement('p');
      note.textContent=config.dataset.preparing||'';note.style.cssText='padding:32px;color:#203265;font:18px/1.6 system-ui,sans-serif';
      target.document.body.appendChild(note);
      const module=await storage();
      return await module.openQuote({config,target,read:()=>options.cartLine?cartProject(options.cartLine):liveBrief()});
    }catch(error){try{if(!target.closed)target.close();}catch(_){}throw error;}
  };
  document.addEventListener('change',event=>{
    const input=event.target;
    if(!input.closest?.('#printq_app, .gcp-packq-embed'))return;
    const w=wrapper();if(!w)return;
    if(input.closest('.gcp-native-field--length,.gcp-native-field--width,.gcp-native-field--height,.gcp-native-field--back-height,.gcp-native-field--front-height,.gcp-native-field--material,.gcp-native-field--flute,.gcp-native-field--print-options')&&input.matches('select,input:not([type="file"]):not([type="hidden"])')){staged.delete(keyFor(w));return;}
    if(!(input instanceof HTMLInputElement)||input.type!=='file')return;
    const file=[...(input.files||[])].find(file=>/\.pdf$/i.test(file.name));
    staged.delete(keyFor(w));
    if(file){
      try{staged.set(keyFor(w),{file,signature:signature(liveFields().specs),revision:crypto.randomUUID(),pending:false,confirmed:''});rememberPath('upload');}catch(_){}
    }
  },true);
  document.addEventListener('click',event=>{
    const action=event.target.closest?.('.gcp-native-action--design,.gcp-native-action--personalize,.gcp-native-action--upload,.gcp-native-upload-utility--delete,.gcp-native-action--cart,[data-gcp-brown-quote],[data-gcp-brown-cart]');
    if(!action)return;
    const w=wrapper(),record=staged.get(keyFor(w));
    if(action.matches('.gcp-native-action--design,.gcp-native-action--personalize')){staged.delete(keyFor(w));rememberPath('personalize');}
    if(action.matches('.gcp-native-action--upload,.gcp-native-upload-utility--delete')){staged.delete(keyFor(w));rememberPath('upload');}
    if(action.matches('.gcp-native-action--cart')&&record){try{const value=liveBrief();pendingUpload=value.file?{value,at:Date.now()}:null;}catch(_){pendingUpload=null;}}
    if(action.matches('[data-gcp-brown-quote],[data-gcp-brown-cart]')){
      event.preventDefault();if(action.hasAttribute('aria-busy'))return;action.setAttribute('aria-busy','true');
      open(action.hasAttribute('data-gcp-brown-cart')?{cartLine:{key:action.dataset.gcpBrownCart}}:{}).catch(error=>{
        let note=action.parentElement.querySelector('.gcp-brown-quote-error');
        if(!note){note=document.createElement('p');note.className='gcp-brown-quote-error';note.setAttribute('role','alert');action.after(note);}
        note.textContent=errorMessage(error);
      }).finally(()=>action.removeAttribute('aria-busy'));
    }
  },true);
  document.addEventListener('on:cart:add',event=>{
    if(event.detail?.source&&event.detail.source!=='packq-cloudlab')return;
    const pending=pendingUpload;pendingUpload=null;
    capturePromise=capturePromise.catch(()=>{}).then(()=>captureCartArtwork(pending,event.detail||{})).catch(()=>false);
  });
  window.GCPBrownQuote=Object.freeze({open,liveBrief,cartBrief,cartProject,captureCartArtwork,errorMessage,quotePage:new URL(config.dataset.page,location.origin).href});
})();
